const STORAGE_KEY = 'badges-last-seen-earned-at';

// Самый поздний earnedAt, с которым уже поздравляли. 0 — ещё ни с чем
export const readSeenAt = (): number => {
  if (typeof window === 'undefined') return 0;

  try {
    const value = Number(localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(value) ? value : 0;
  } catch {
    // приватный режим — поздравим ещё раз, это не страшно
    return 0;
  }
};

export const writeSeenAt = (earnedAt: number): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(STORAGE_KEY, String(earnedAt));
  } catch {
    // не удалось запомнить — окно вернётся, данные не теряются
  }
};
